<template>
  <div id="app">
    <component
      v-in-viewport="-400"
      v-for="(section, key) in sections"
      :ref="getContainerRef(section.id)"
      :is="section.section"
      :content="section.content"
      :tracking="section.tracking"
      :id="section.id"
      :key="key">
    </component>
  </div>
</template>

<script>
import DefaultContainer from './containers/DefaultContainer'
import FixedScrollContainer from './containers/FixedScrollContainer'
import IntroSection from './sections/IntroSection'
import VideoSection from './sections/VideoSection'
import SmallVideoSection from './sections/SmallVideoSection'
import GameSection from './sections/GameSection'
import InfoSection from './sections/InfoSection'
import SolutionSection from './sections/SolutionSection'
import FooterSection from './sections/FooterSection'
import BubbleSection from './sections/BubbleSection'
import VueScrollTo from 'vue-scrollto'
import inViewport from 'vue-in-viewport-directive'
import appData from '@/data.json'

export default {
  directives: {
    inViewport,
    'scroll-to': VueScrollTo
  },
  name: 'app',
  components: {
    appData,
    BubbleSection,
    DefaultContainer,
    FixedScrollContainer,
    IntroSection,
    VideoSection,
    SmallVideoSection,
    GameSection,
    InfoSection,
    SolutionSection,
    FooterSection
  },
  data () {
    return {
      sections: appData.sections,
      videoAllowed: false,
      aboveSeaAudio: true
    }
  },

  methods: {
    getContainerRef (id) {
      return `${id}-container`
    }
  }
}
</script>
<style lang="scss">
  * {
    box-sizing: border-box;
  }

  body,
  html {
    background-color: $nos-op3-dark-blue;
    font-family: $base-font;
    font-size: 1em;
    line-height: 1.5em;
    margin: 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue